import { product } from "../../utils/domain/model.js";
import { state } from "../../state/workspaceStore.js";
export function applicabilityText(c) {
  if (c.applicability !== "selected") return "All products";
  return (
    (c.productIds || [])
      .map((pid) => {
        const p = product(state.db, pid);
        return p
          ? p.name +
              (!p.archived && p.status === "Active" ? "" : " (unavailable)")
          : "Removed product · " + pid;
      })
      .join(", ") || "No products selected"
  );
}
